import '../style.css';
import { mountKongFortress } from './game';

mountKongFortress();
